import React from 'react';

import Layout from '../components/layout'
import Head from '../components/head'

const ContactPage = () => {
  return(
    <Layout>
      <Head title="Contact" />
      <p>
        The best way to reach me is via <a href='https://instagram.com/ryantyler.xo' target='_blank' rel='noopener noreferrer'>@ryantyler.xo</a> on Instagram
      </p>
    </Layout>
  )
}

export default ContactPage